import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import FeedbackForm from './FeedbackForm';
import useFeedbackModal from './hooks/useFeedbackModal';
import ChatFeedbackChoice from './ChatFeedbackChoice';

// id for website template
// const defaultTempId = '6aec15f7-f46e-4bca-8328-d8294a82679b';

const FeedbackModal = ({
  siteFormat,
  feedbackModalOpen,
  handleOpenFeedbackModal,
  store,
  isStoreFeedback,
  triggerPushSurvey,
  handleGeneralFeedback,
}) => {
  const {
    hover,
    selectedExp,
    selectedState,
    templateTypes,
    selectedTemplate,
    loading,
    error,
    errorMessage,
    submitSuccess,
    attemptedSubmit,
    answersObj,
    handleSelectedExp,
    handleInput,
    handleBlur,
    handleSelectYoN,
    handleResetFeedbackModal,
    handleHover,
    handleSelectState,
    handleSubmitFeedback,
    liveChatOnClick,
  } = useFeedbackModal(handleOpenFeedbackModal, store, isStoreFeedback, triggerPushSurvey, handleGeneralFeedback);

  const [isChoice, setIsChoice] = useState(true);

  const handleLeaveFeedbackClick = () => {
    setIsChoice(false);
  };

  return (
    <div>
      <Modal
        portalClassName={'ReactModalPortal dds'}
        id='feedback_modal'
        className='QvModal__Content ReactModal__KeepOpenFor_OSS feedback_modal'
        overlayClassName='QvModal__Overlay ReactModal__KeepOpenFor_OSS'
        isOpen={feedbackModalOpen}
      >
        {isChoice ? (
          <ChatFeedbackChoice
            liveChatOnClick={liveChatOnClick}
            siteFormat={siteFormat}
            handleResetModal={handleResetFeedbackModal}
            handleLeaveFeedbackClick={handleLeaveFeedbackClick}
          />
        ) : (
          <FeedbackForm
            handleResetModal={handleResetFeedbackModal}
            handleHover={handleHover}
            handleSelectedExp={handleSelectedExp}
            hover={hover}
            selectedExp={selectedExp}
            templateTypes={templateTypes}
            selectedTemplate={selectedTemplate}
            selectedState={selectedState}
            handleSelectState={handleSelectState}
            loading={loading}
            error={error}
            errorMessage={errorMessage}
            handleSubmitFeedback={handleSubmitFeedback}
            handleInput={handleInput}
            handleBlur={handleBlur}
            handleSelectYoN={handleSelectYoN}
            submitSuccess={submitSuccess}
            attemptedSubmit={attemptedSubmit}
            siteFormat={siteFormat}
            answersObj={answersObj}
          />
        )}
      </Modal>
    </div>
  );
};

export default FeedbackModal;
